import request from '@/util/request';



export const firmwareUpload = (formData) => {
    return request({
      url: '/api/v4ward/park/firmware/upload',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    });
  };
 export const firmwarePage = (params, options) =>
request.get(
  '/api/v4ward/park/firmware/page',
  Object.assign({}, options, { params })
);

export const firmwareRemove = (id) => request.post('/api/v4ward/park/firmware/remove?ids='+id);
